module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-main-menu-match__team"
  }, [_c('router-link', {
    staticClass: "u-marg-l-xxs u-marg-b-xxxs",
    attrs: {
      "to": _vm._getLink()
    }
  }, [_c('span', {
    staticClass: "t-lspacing--md t-text--xs t-text--bold u-uppercase u-color--gray-ldark u-valign-middle",
    domProps: {
      "innerHTML": _vm._s(_vm._getBeginsDate())
    }
  }), _vm._v(" "), (_vm.displayGame) ? [(_vm.match.videoGameId === 1) ? _c('img', {
    staticClass: "c-main-menu-match__logo u-valign-middle u-marg-l-xxs u-opacity--5",
    attrs: {
      "src": require("../../../assets/games/counter-strike-global-offensive-w100.png"),
      "alt": "CS:GO"
    }
  }) : (_vm.match.videoGameId === 2) ? _c('img', {
    staticClass: "c-main-menu-match__logo u-valign-middle u-marg-l-xxs u-opacity--5",
    attrs: {
      "src": require("../../../assets/games/street-fighter-v-w100.png"),
      "alt": "Street Fighter V"
    }
  }) : (_vm.match.videoGameId === 3) ? _c('img', {
    staticClass: "c-main-menu-match__logo u-valign-middle u-marg-l-xxs u-opacity--5",
    attrs: {
      "src": require("../../../assets/games/rocket-league-w100.png"),
      "alt": "Rocket League"
    }
  }) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "u-vacuum u-pad-y-xxs u-flex--x u-flex--align-items--center"
  }, [_c('div', {
    staticClass: "u-w1of4 u-align-center"
  }, [_c('img', {
    staticClass: "u-inline-block u-valign-middle",
    attrs: {
      "src": _vm.matchData.teamOne.logotype,
      "alt": _vm.matchData.teamOne.accronym,
      "height": "22",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-middle u-w1of4 u-color--white u-align-left t-text--sm u-uppercase t-text--bold"
  }, [_vm._v(_vm._s(_vm.matchData.teamOne.accronym))]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-middle u-w2of4 u-color--white t-text--sm u-uppercase t-text--bold"
  }, [_vm._v(_vm._s(_vm.hideScore ? '-' : _vm.matchData.teamOneScore))])]), _vm._v(" "), _c('div', {
    staticClass: "c-main-menu-match__separator u-height-1 u-bg--gray-dark u-opacity--6"
  }), _vm._v(" "), _c('div', {
    staticClass: "u-vacuum u-pad-y-xxs u-flex--x u-flex--align-items--center"
  }, [_c('div', {
    staticClass: "u-w1of4 u-align-center"
  }, [_c('img', {
    staticClass: "u-inline-block u-valign-middle",
    attrs: {
      "src": _vm.matchData.teamTwo.logotype,
      "alt": _vm.matchData.teamTwo.accronym,
      "height": "22",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-middle u-w1of4 u-color--white u-align-left t-text--sm u-uppercase t-text--bold"
  }, [_vm._v(_vm._s(_vm.matchData.teamTwo.accronym))]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-middle u-w2of4 u-color--white t-text--sm u-uppercase t-text--bold"
  }, [_vm._v(_vm._s(_vm.hideScore ? '-' : _vm.matchData.teamTwoScore))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70e3fd7c"}!./src/scripts/components/app-menu-match/template.html
// module id = 934
// module chunks = 0